import { Node } from "reactflow";

// we need to make sure that the parents are sorted before the children
// to make sure that the children are rendered on top of the parents
// TODO: sort nodes when adding group node
export function sortNodes(a: Node, b: Node) {
  if (a.type === b.type) {
    return 0;
  }
  return a.type === "group" && b.type !== "group" ? -1 : 1;
}
